import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import Nav from "@/components/layout/Nav";
import Footer from "@/components/layout/Footer";
import Landing from "@/pages/Landing";
import Triage from "@/pages/Triage";
import Checklist from "@/pages/Checklist";
import RiskWatch from "@/pages/RiskWatch";
import RiskScreen from "@/pages/RiskScreen";
import PortfolioScreening from "@/pages/PortfolioScreening";
import AdminLeads from "@/pages/AdminLeads";
import AuthCallback from "@/pages/AuthCallback";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Disclaimer from "@/pages/Disclaimer";
import ScrollToHash from "@/components/ScrollToHash";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
function AppRouter() {
  const location = useLocation();
  // Synchronous session_id detection (must run before other route logic)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  const isAdminPage = location.pathname.startsWith("/admin-leads");
  return (
    <div className="min-h-screen flex flex-col">
      <ScrollToHash />
      {!isAdminPage && <Nav />}
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/triage" element={<Triage />} />
          <Route path="/checklist" element={<Checklist />} />
          <Route path="/risk-watch" element={<RiskWatch />} />
          <Route path="/risk-screen" element={<RiskScreen />} />
          <Route path="/portfolio-screening" element={<PortfolioScreening />} />
          <Route path="/admin-leads" element={<AdminLeads />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/disclaimer" element={<Disclaimer />} />
        </Routes>
      </main>
      {!isAdminPage && <Footer />}
      <Toaster theme="dark" position="top-right" />
    </div>
  );
}

export default function App() {
  useEffect(() => {
    document.title = "PFAS Risk Intelligence — PFAS-specific intelligence for land and development decisions";
  }, []);
  return (
    <BrowserRouter>
      <AppRouter />
    </BrowserRouter>
  );
}
